import { Record } from 'immutable';
import * as types from './actionTypes';

const requestReducerState = Record({
  data: [],
  fetching: false,
});

export default (state = requestReducerState(), action) => {
  const { type, payload } = action;
  switch (type) {
    case types.TRANSLATION_RULES_REQUEST:
      return state.set('fetching', true).set('data', []);
    case types.SET_TRANSLATION_RULES:
    case types.TRANSLATION_RULES_SUCCESS:
      return state.set('fetching', false).set('data', payload);
    case types.TRANSLATION_RULES_FAILURE:
      return state.set('fetching', false);
    default:
      return state;
  }
};
